import * as React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import { RenderErrorMessage } from '../error/RenderErrorMessage'
import { Page } from '../page/Page'

/**
 * Intended to be run with potentially unsafe rendering code and catch any errors
 * If something throws, it shows an error message with an ice cream and reports the error
 */
export function renderCatch(deps: CommonDeps, tryRender: () => React.ReactElement<unknown>) {
    try {
        return tryRender()
    } catch (error) {
        deps.reportError(error)

        return (
            <RenderErrorMessage
                getImage={deps.getImage}
                language={deps.language}
                triggerSentryReplay={deps.triggerSentryReplay}
            />
        )
    }
}

/**
 * Like renderCatch, but keeps a page layout with a header
 */
export function renderCatchPage(
    deps: CommonDeps,
    header: React.ReactElement<unknown>,
    tryRender: () => React.ReactElement<unknown>
) {
    try {
        return tryRender()
    } catch (error) {
        deps.reportError(error)

        return (
            <Page deps={deps} header={header}>
                <RenderErrorMessage
                    getImage={deps.getImage}
                    language={deps.language}
                    triggerSentryReplay={deps.triggerSentryReplay}
                />
            </Page>
        )
    }
}
